import { useNavigate } from "react-router-dom";
import { useState } from "react";
import APIService from "../../services/Api";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ImSpinner9 } from "react-icons/im";
import {  MdError } from "react-icons/md";
import {  FaUserPlus, FaUserTie } from "react-icons/fa";
import { BsCashStack } from "react-icons/bs";
import { useAppStateContext } from "src/auth/AppStateContext";
import { IoIosArrowDroprightCircle } from "react-icons/io";
import isfLogo from "../../assets/images/logo/isflogo-transparent.png";

type RegisterFormParams = {
  disableImage?: boolean;
  disabledBackground?: boolean;
};
const RegisterForm = ({
  disableImage,
  disabledBackground,
}: RegisterFormParams) => {
  const [response, setResponse] = useState<string>("");
  const [cashierApodo, setCashierApodo] = useState<string>("");
  const { setShowRegisterPopup } = useAppStateContext();
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const onChangeCode = (e: React.FormEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    setCashierApodo(value.trim());
  };
  const verifyCode = async () => {
    setLoading(true);
    let cc = cashierApodo.trim();
    if (!cc.includes("-") && cc.length === 6) {
      cc = cc.substring(0, 3) + "-" + cc.substring(3, cc.length);
    }
    const res = await APIService.systemVerifyCashierApodo({ apodo: cc });
    setResponse(res?.data?.data?.registerlink);
    if (res?.data?.data?.registerlink !== "notfound") {
      setShowRegisterPopup(false);
      navigate(`/${cc}`);
    }
    setLoading(false);
  };
  const handleGoRegister = (url: string) => {
    setShowRegisterPopup(false);
    navigate(url);
  };

  return (
    <section className="min-h-screen relative bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center p-4">
      <ToastContainer
        position="bottom-center"
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <img src={isfLogo} alt="logo" className="w-10 md:w-14 top-3 h-auto absolute" />
      <div className="w-full max-w-6xl mx-auto">
        <section className="px-4 md:px-8 py-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto">
              {/* Cliente Section */}
              <div className="bg-gray-800 rounded-2xl shadow-xl p-8 border border-gray-700">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 bg-gradient-to-r from-green-admin to-green-admin-dark rounded-xl flex items-center justify-center shadow-lg">
                    <FaUserPlus className="text-white text-xl" />
                  </div>
                  <h2 className="text-2xl font-bold text-white">Unirse como Cliente</h2>
                </div>

                {!loading ? (
                  <div className="space-y-6">
                    {/* Opción sin apodo */}
                    <div className="bg-gradient-to-r from-gray-700 to-gray-600 rounded-xl p-6 border border-gray-600">
                      <h3 className="font-semibold text-white mb-3 flex items-center gap-2">
                        <div className="w-2 h-2 bg-green-admin rounded-full"></div>
                        ¿No conoces el apodo de algún cajero?
                      </h3>
                      <p className="text-gray-300 text-sm mb-4">
                        Puedes registrarte y después seleccionar un cajero.
                      </p>
                      <button
                        onClick={() => handleGoRegister("/registro-usuario")}
                        className="bg-gradient-to-r from-green-admin to-green-admin-dark hover:from-green-admin-dark hover:to-green-admin text-white font-semibold px-6 py-3 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center gap-2"
                      >
                        <IoIosArrowDroprightCircle size={20} />
                        Continuar
                      </button>
                    </div>

                    {/* Opción con apodo */}
                    <div className="space-y-4">
                      <h3 className="font-semibold text-white flex items-center gap-2">
                        <div className="w-2 h-2 bg-green-admin rounded-full"></div>
                        ¿Conoces el apodo del cajero?
                      </h3>
                      <p className="text-gray-300 text-sm">
                        Escribe el apodo del cajero para registrarte.
                      </p>
                      
                      <div className="space-y-3">
                        <input
                          type="text"
                          value={cashierApodo}
                          placeholder="Escribe el apodo..."
                          onChange={onChangeCode}
                          className="w-full px-4 py-3 border border-gray-600 rounded-xl focus:ring-2 focus:ring-green-admin focus:border-transparent transition-all duration-300 bg-gray-700 text-white placeholder-gray-400 shadow-sm"
                        />
                        <button
                          onClick={() => verifyCode()}
                          className="w-full bg-gradient-to-r from-green-admin to-green-admin-dark hover:from-green-admin-dark hover:to-green-admin text-white font-semibold px-6 py-3 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
                        >
                          Verificar y Continuar
                        </button>
                      </div>

                      {response === "notfound" && (
                        <div className="bg-red-900/50 border border-red-700 rounded-xl p-4 flex items-center gap-3">
                          <MdError className="text-red-400" size={20} />
                          <span className="text-red-300 font-medium text-sm">
                            El código ingresado no fue encontrado.
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="flex items-center justify-center py-8">
                    <div className="text-center">
                      <ImSpinner9 className="animate-spin text-green-admin mx-auto mb-4" size={40} />
                      <p className="text-gray-300 font-medium">Verificando el código...</p>
                    </div>
                  </div>
                )}
              </div>

              {/* Cajero Section */}
              <div className="bg-gray-800 rounded-2xl shadow-xl p-8 border border-gray-700">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 bg-gradient-to-r from-green-admin to-green-admin-dark rounded-xl flex items-center justify-center shadow-lg">
                    <FaUserTie className="text-white text-xl" />
                  </div>
                  <h2 className="text-2xl font-bold text-white">Unirse como Cajero</h2>
                </div>

                <div className="space-y-4 mb-6">
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-green-admin rounded-full mt-2"></div>
                    <p className="text-gray-300">Registra tus porcentajes de ganancias.</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-green-admin rounded-full mt-2"></div>
                    <p className="text-gray-300">Elige los bancos y wallets de pago con los que deseas trabajar.</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-green-admin rounded-full mt-2"></div>
                    <p className="text-gray-300">Obtén tu propio dashboard de operaciones.</p>
                  </div>
                </div>

                <button
                  onClick={() => handleGoRegister("/registro-cajero")}
                  className="w-full bg-gradient-to-r from-green-admin to-green-admin-dark hover:from-green-admin-dark hover:to-green-admin text-white font-semibold px-6 py-3 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
                >
                  <BsCashStack size={20} />
                  Registrarme como Cajero
                </button>
              </div>
            </div>
          </section>
        </div>
      </section>
  );
};

export default RegisterForm;
